import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import useAuthToken from "../../../../hooks/useAuthToken";
import styles from "./css/PaymentTable.module.scss";

const PaymentTable = ({
  apiEndpoint,
  rows,
  payments,
  setPayments,
  planName,
  transactionId,
  userId,
  searchTerm,
  currentPage,
  setCurrentPage,
  sortField,
  sortOrder,
  setSortField,
  setSortOrder,
  loading,
  setLoading,
}) => {
  const { token } = useAuthToken();
  const [products, setProducts] = useState([]);
  const navigate = useNavigate();

  // useEffect(() => {
  //   const fetchPayments = async () => {
  //     try {
  //       setLoading(true);
  //       const queryParams = new URLSearchParams();

  //       if (searchTerm) {
  //         queryParams.set("search", searchTerm);
  //       }
  //       if (planName) {
  //         queryParams.set("plan_name", planName);
  //       }
  //       if (transactionId) {
  //         queryParams.set("revenuecat_transaction_id", transactionId);
  //       }
  //       if (userId) {
  //         queryParams.set("user_id", userId);
  //       }

  //       queryParams.set("page", currentPage);
  //       queryParams.set("pageSize", rows);
  //       queryParams.set("sort_by", sortField);
  //       queryParams.set("order_by", sortOrder);

  //       const fullURL = `${apiEndpoint}?${queryParams.toString()}`;

  //       const response = await fetch(fullURL, {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //         },
  //       });

  //       if (!response.ok) {
  //         throw new Error("Network response was not ok");
  //       }

  //       const data = await response.json();
  //       setPayments(data.data.user_subscriptions || []);
  //     } catch (error) {
  //       console.error("Error fetching data:", error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchPayments();
  // }, [
  //   apiEndpoint,
  //   rows,
  //   currentPage,
  //   sortField,
  //   sortOrder,
  //   searchTerm,
  //   planName,
  //   transactionId,
  //   userId,
  // ]);

  const columns = [
    {
      field: "id",
      header: "Sr No.",
      className: styles["column-id"],
      sortable: true,
    },
    {
      header: "User Name",
      className: styles["column-username"],
      sortable: false,
      body: (rowData) =>
        rowData.user
          ? `${rowData.user.firstname || ""} ${rowData.user.lastname || ""}`
          : "N/A",
    },
    {
      field: "user.email",
      header: "User Email",
      className: styles["column_user_mobile"],
      sortable: true,
      body: (rowData) => (rowData.user ? `${rowData.user.email || ""}` : "N/A"),
    },
    {
      field: "subscription_data.title",
      header: "Plan Name",
      className: styles["column_plan_name"],
      sortable: true,
    },

    {
      field: "amount",
      header: "Amount",
      className: styles["column_amount"],
      sortable: true,
    },
    {
      field: "revenuecat_transaction_id",
      header: " Transaction ID",
      className: styles["column_transaction_id"],
      sortable: false,
    },
    // {
    //   field: "platform_type",
    //   header: "Platform Type",
    //   className: styles["column_platform_type"],
    //   sortable: true,
    // },
    {
      field: "environment",
      header: "Environment",
      className: styles["column_environment"],
      sortable: true,
    },
    {
      field: "country_code",
      header: "Country",
      className: styles["column_country_code"],
      sortable: true,
    },
    {
      field: "currency",
      header: "Currency",
      className: styles["column_currency"],
      sortable: true,
    },
    {
      field: "subscription_status_type",
      header: "Subscription Status",
      className: styles["column_subscription_status_type"],
      sortable: true,
    },
    // {
    //   field: "createdAt",
    //   header: "Purchase Date",
    //   className: styles["column_created_at"],
    //   sortable: true,
    //   body: (rowData) => format(new Date(rowData.createdAt), "dd-MM-yyyy"),
    // },
    // {
    //   field: "expired_at",
    //   header: "Expired Date",
    //   className: styles["column_expired_at"],
    //   sortable: true,
    //   body: (rowData) => format(new Date(rowData.expired_at), "dd-MM-yyyy"),
    // },
  ];

  const handlePageChange = (event) => {
    setCurrentPage(event.page + 1);
  };

  const handleSort = (event) => {
    setSortField(event.sortField);
    setSortOrder(event.sortOrder === 1 ? "ASC" : "DESC");
    setCurrentPage(1);
  };

  return (
    <>
      <div className={`${styles.main}`}>
        <DataTable
          className={`${styles.datatable}`}
          value={payments}
          rows={rows}
          first={(currentPage - 1) * rows}
          onPage={handlePageChange}
          totalRecords={payments.length}
          sortField={sortField}
          sortOrder={sortOrder === "ASC" ? 1 : -1}
          onSort={handleSort}
          emptyMessage={
            loading ? (
              <div className={styles.loading_row}>
                <div className={styles.spinner}></div>
              </div>
            ) : (
              <div className={styles["no-data-message"]}>
                No data to display.
              </div>
            )
          }
        >
          {columns.map((col, i) => (
            <Column
              key={i}
              field={col.field}
              header={col.header}
              sortable={col.sortable}
              headerClassName={`${styles["column-header-small"]} ${col.className}`}
              bodyClassName={col.className}
              body={col.body}
            />
          ))}
        </DataTable>
      </div>
    </>
  );
};

export default PaymentTable;
